/* eslint-disable default-case */
import React from 'react';
import { DocPage } from './components/DocPage';
import { Page404, HomePage } from './pages/Others';
import Interface from './pages/Interface';
import TypeAlias from './pages/TypeAlias';
import Constant from './pages/Constant';
import Func from './pages/Function';
import Enum from './pages/Enum';
import Class from './pages/Class';
import * as Manager from './utils/Manager';
import useHighlight from './utils/Highlight';

export default function App() {
    window.addEventListener('load', useHighlight);

    if(Manager.params.length === 1) return <HomePage/>
    else if (Manager.moduleNames.includes(Manager.moduleName)) {
        if (!Manager.name) return <HomePage/>

        const documentation = Manager.getDocumentation();
        if (!documentation) return <Page404/>;

        const LoadComponent = ({ component: Component }) => <DocPage>
            <Component docs={documentation}/>
            <div style={{ height: '50px' }}></div>
        </DocPage>

        switch (Manager.type) {
            case "interface": return <LoadComponent component={Interface}/>
            case "typeAlias": return <LoadComponent component={TypeAlias}/>
            case "constant": return <LoadComponent component={Constant}/>
            case "function": return <LoadComponent component={Func}/>
            case "enum": return <LoadComponent component={Enum}/>
            case "class": return <LoadComponent component={Class}/>
        }
    }

    return <Page404/>
}